import React from 'react'

const AdminErStore = () => {
  return <div>AdminErStore</div>
}

export default AdminErStore
